import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef, useState } from 'react';
import { X, XCircle, HelpCircle, CheckCircle, Info } from 'react-feather';
import { config, Transition, animated } from 'react-spring';
import defaultStyles from './styles/Alert.module.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const Alert = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    theme,
    action,
    variant = 'default',
    title,
    content,
    icon,
    showIcon = true,
    closable = false,
    afterClose,
    onClose,
    closeElement
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const [visible, setVisible] = useState(true);
  const springConfig = {
    from: {
      opacity: 1,
      config: config.stiff
    },
    to: {
      opacity: 0,
      config: config.stiff
    }
  };
  function renderIcon(type) {
    if (icon) {
      return icon;
    }
    switch (type) {
      case 'default':
        return /*#__PURE__*/jsx(Info, {});
      case 'success':
        return /*#__PURE__*/jsx(CheckCircle, {});
      case 'warning':
        return /*#__PURE__*/jsx(HelpCircle, {});
      case 'error':
        return /*#__PURE__*/jsx(XCircle, {});
      default:
        return null;
    }
  }
  function onHandleClose(e) {
    setVisible(false);
    onClose && onClose(e);
  }
  const vairantClasses = {
    [styles.default]: variant === 'default',
    [styles.success]: variant === 'success',
    [styles.warning]: variant === 'warning',
    [styles.error]: variant === 'error'
  };
  const alertClassNames = clsx(styles.root, {
    [styles.with_title]: title,
    ...vairantClasses
  });
  return /*#__PURE__*/jsx(Transition, {
    native: true,
    onDestroyed: () => {
      afterClose && afterClose();
    },
    items: visible,
    from: springConfig.from,
    enter: springConfig.from,
    leave: springConfig.to,
    children: (transitionStyles, item) => item && /*#__PURE__*/jsxs(animated.div, {
      ref: ref,
      style: {
        ...transitionStyles
      },
      className: alertClassNames,
      children: [showIcon && /*#__PURE__*/jsx("div", {
        className: styles.icon,
        children: renderIcon(variant)
      }), /*#__PURE__*/jsxs("div", {
        className: styles.content,
        children: [title && /*#__PURE__*/jsx("div", {
          className: styles.title,
          children: title
        }), content && /*#__PURE__*/jsx("div", {
          className: styles.text,
          children: content
        })]
      }), action && /*#__PURE__*/jsx("div", {
        className: styles.action,
        children: action
      }), closable && /*#__PURE__*/jsx("button", {
        type: "button",
        onClick: onHandleClose,
        className: styles.close,
        children: closeElement || /*#__PURE__*/jsx(X, {})
      })]
    })
  });
});
Alert.displayName = 'Alert';

export { Alert };
